import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import MainContent from '../../../components/MainContent';
import PageTitle from '../../../components/Common/PageTitle/PageTitle';
import Pagination from '../../../components/Common/Pagination';
import ActivityLoader from '../../../components/Common/ActivityLoader';
import Notification from '../../../components/Common/Notification';
import ActionDropdownItem from '../../../components/Common/PageTitle/ActionDropdownItem';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../DataStore/ThemeContext';
import functions from '../../../util/functions';
import { useGymCustomer } from '../../../DataStore/Gym/GymCustomerContext';

const CustomerListingPage = () => {
    const [showProfile, setShowProfile] = useState(false);
    const [selection, setSelelection] = useState(false);

    const {
        metaData, 
        getGymCustomers, 
        GymCustomerListing, 
        setCurrentPage, 
        setSelectedGymCustomer, 
    } = useGymCustomer();

    const { setNotify, openSettings } = useTheme();

    const navigate = useNavigate();

    useEffect(() => {
        getGymCustomers();
    }, []);

    const handleNew = () => {
        // navigate('/vendor-new')
    };

    const PageActions = () => (<>
        <ActionDropdownItem iconClass="fa fa-pencil text-success" label="Register New" onClick={handleNew} />
        <ActionDropdownItem iconClass="fa fa-refresh text-info" label="Refresh" onClick={() => getGymCustomers(true)} />
    </>);

    const goToProfile = (profileInfo) => {
        setSelectedGymCustomer(profileInfo);
        setShowProfile(true);
    };

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Gym Customers"
                    description="List of all your business customers."
                    iconClass="fas fa-user-shield"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                    /> : <></>}
                />

                <div className="card mb-3">
                    <div className="card-body">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Date of Registration</th>
                                    <th>Membership</th>
                                    <th>Status</th>
                                    <th>Expiry</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(GymCustomerListing) && GymCustomerListing.map((item, key) => (
                                    <tr key={key} onClick={() => setSelelection(item)} className={`link ${selection?.id === item.id ? 'selected-row' : ''}`}>
                                        <td>{key + 1}</td>
                                        <td><span className="text-primar link">{item.full_name}</span></td>
                                        <td>{item.phone_number}</td>
                                        <td>{item.created_at ? functions.formatDate(item.created_at) : 'N/A'}</td>
                                        <td>{item.membership_type?.type_name}</td>
                                        <td>{item.membership_status}</td>
                                        <td>{item.membership_expiry ? functions.formatDate(item.membership_expiry) : 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {!GymCustomerListing && <ActivityLoader />}
                        {GymCustomerListing === "404" && <Notification message="No customer record found" closable={false} />}
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default CustomerListingPage;
